import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { UserInfo } from './shared/user-info.model';
import { JwtHelperService } from '@auth0/angular-jwt';
import { CompanyService } from '../business/shared/company.service';
import { Company } from '../business/shared/company';
import { CryptoService } from '../shared/crypto/crypto.service';
import { InfoUserService } from './shared/info-user.service';
import { ModuloService } from '../parametricas/shared/modulo.service';
import { GenericResult } from '../globalClass/generic-class.model';
import { ToastrService } from 'ngx-toastr';
import { Select2OptionData } from 'ng-select2';
import { FormGroup, FormBuilder } from '@angular/forms';
import { LoginService } from '../pages/login/shared/login.service';


@Component({
  selector: 'app-info-user',
  templateUrl: './info-user.component.html'
})
export class InfoUserComponent implements OnInit {
  userSesion: UserInfo;
  empresa: Company;
  formBissness: FormGroup;

  companySelect: string = "";
  messageLoader: string = "Cargando ...";

  isLoader: boolean = false;

  listBissness: Array<Select2OptionData> = [];

  @Input() home: boolean;
  @Input() configuracion: boolean;
  @Output() changeCompany = new EventEmitter<any>();

  isWeCump:boolean=false;
  constructor(
    private jwtHelper: JwtHelperService,
    private empresaService: CompanyService,
    private encryptService: CryptoService,
    private _infoUserService: InfoUserService,
    private _moduloService: ModuloService,
    private _toastr: ToastrService,
    private _fb: FormBuilder,
    private _loginService: LoginService
  ) {
    //debugger;
    this.getDataUser();
  }

  ngOnInit() {
    //debugger;
    this.validateIsWeCump();
  }

  createForm() {
    this.formBissness = this._fb.group({
      ddlBissness: [null]
    });
  }


  getDataUser() {
    //debugger;
    this.createForm();

    if (sessionStorage.getItem('jwt') != null) {
      if (sessionStorage.getItem('userInfo') == null) {
        let stringJwt = sessionStorage.getItem('jwt');
        let token = this.jwtHelper.decodeToken(stringJwt);
        let jwtUser = token.payLoad.user;
        let user = new UserInfo();
        user.idUser = jwtUser.IdSegUsuario;
        user.typeDoc = jwtUser.IdTipoDocumento;
        user.typePerson = jwtUser.IdSegTipoPersona;
        user.docNumber = jwtUser.NumeroDocumento;
        user.email = jwtUser.CorreoElectronico;
        user.name = jwtUser.Nombre;
        user.lastName = jwtUser.Apellido1;
        user.sourName = jwtUser.Apellido2;
        user.role = jwtUser.SegRolUsuario;
        this.userSesion = user;
        let item = this.encryptService.encrypt(JSON.stringify(user));
        sessionStorage.setItem('userInfo', item);
        this.loadBusiness(this.userSesion.idUser);
      } else {
        let temp = sessionStorage.getItem('userInfo');
        let item = this.encryptService.decrypt(temp);
        this.userSesion = JSON.parse(item) as UserInfo;
        this.loadBusiness(this.userSesion.idUser);
      }
    }
  }

  loadBusiness(id: number) {
    debugger;
    this.empresaService.getCompanyByUser(id).then(() => {
      for (let i = 0; i < this.empresaService.companyList.length; i++) {
        this.listBissness.push({ id: this.empresaService.companyList[i].idAdmEmpresa.toString(), text: this.empresaService.companyList[i].nombre });
      }

      if (typeof (this.userSesion.company) != 'undefined') {
        this.formBissness.patchValue({ ddlBissness: `${this.userSesion.company.idAdmEmpresa}` });
      }else{
        this.formBissness.patchValue({ ddlBissness: `` });
      }
    });
  }

  valueCompanyName() {
    return (typeof (this.userSesion.company) != 'undefined') ? this.userSesion.company.nombre : "";
  }

  enviarModulo(modulos: any[]) {
  }

  async onChange(event) {
    //debugger
    this.isLoader = true;
    this.companySelect = event;

    if (this.empresaService.companyList && event) {
      let status: any = this.empresaService.companyList.find(s => s["idAdmEmpresa"] == parseInt(event));

      if (status) {
        let compania = new Company();
        compania.nombre = status.nombre;
        compania.idAdmEmpresa = status.idAdmEmpresa;
        compania.nit = status.nit;
        this.userSesion.company = compania;
        let item = this.encryptService.encrypt(JSON.stringify(this.userSesion));
        sessionStorage.setItem('userInfo', item);
        await this._infoUserService.getMenuModules(this.userSesion.idUser, status.idAdmEmpresa).then((r: GenericResult) => {
          //debugger
          if (r.error) {
            this._toastr.error(`Error: ${r.codError} - ${r.message}`);
          } else {
            if (r.result.token == ""){
              //this._toastr.warning(`La acción no se puede ejecutar debido a que usted no cuenta con un token valido por favor Cierre e Inicie nuevamente su sesión`)
            }else{
              let modulos = r.result.modulos;
              let token = r.result.token;
              sessionStorage.setItem("jwt", token);
              modulos.push(-100);
              this.userSesion.modules = modulos;
              let item = this.encryptService.encrypt(JSON.stringify(this.userSesion));
              sessionStorage.setItem('userInfo', item);
              this.setModule(modulos);
            }
          }
        });
      }
    }
    else {
      this.companySelect = '';
    }
    this.changeCompany.emit(true);

    this.isLoader = false;
  }

  setModule(modulo) {
    if (this._moduloService.sendModulesFn) {
      this._moduloService.sendModulesFn(modulo);
    }
  }

  validateIsWeCump(){
    this._loginService.validateIsWeCump(this.userSesion.idUser).then((r: GenericResult) => {
      if (r.error) {
        this._toastr.error(`Error: ${r.codError} - ${r.message}`);
      } else {
        if(r.result.userIsRolWeCump && r.result.isOnlyCampanyWillis){
          this.isWeCump=true;
          this.onChange(r.result.idCompany);
        }else{
          this.isWeCump=false;
        }
      }
      if(this.home){
        this.home=!this.isWeCump;
      }
    });
  }
}
